import { Suspense, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import RouteErrorBoundary from '@/components/system/RouteErrorBoundary';

export default function RouteSuspense({ children }: { children: ReactNode }) {
  const location = useLocation();

  return (
    <RouteErrorBoundary resetKey={location.pathname}>
      <Suspense fallback={<div className="p-6 text-sm text-gray-500">Cargando...</div>}>
        {children}
      </Suspense>
    </RouteErrorBoundary>
  );
}
